import { Badge } from '@/components/ui';
import type { Bill } from '@/features/billing/types';

export function BillStatusBadge({ bill }: { bill: Bill }) {
  if (bill.status === 'void') return <Badge>Void</Badge>;
  if (bill.status === 'closed')
    return bill.refundPendingSen > 0 ? (
      <Badge tone="warning">Paid · refund pending</Badge>
    ) : bill.refundedSen > 0 ? (
      <Badge tone="neutral">Paid · refunded</Badge>
    ) : (
      <Badge tone="success">Paid</Badge>
    );
  if (bill.voidRequest && !bill.voidRequest.decidedAt)
    return <Badge tone="warning">Void requested</Badge>;
  if (
    bill.approvals.some((a) => a.kind === 'discount' && a.status === 'pending')
  )
    return <Badge tone="warning">Discount waiting</Badge>;
  if (bill.duitNow) return <Badge tone="info">Waiting for the bank</Badge>;
  return <Badge tone="info">Open</Badge>;
}
